module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray@3x-636b47e792c60c3c35951511fbe53584.png";